import styled from 'styled-components';

export const RegisterContactModule = styled.div.attrs({
    className: 'styled-register-contact-module',
})``;
